<template>
  <div
    class="home"
    style="position:relative;"
    :dir="isHebrew ? 'rtl' : 'ltr'"
    >
    <AddAtractionFromImage v-if="!isUserManager"/>
    <AddAccommodationFromImage v-if="!isUserManager" />
    
    <!-- Language Toggle Button -->
    <!-- <div class="language-toggle-container">
      <LanguageToggle />
    </div> -->
        
    <div v-if="rideHeader" class="single_ride_header">
      <SingleRideHeader
        presentedText="RIDE_TITLE"
        :compact="design.compactHeader"
       />
    </div>
    <SharedRideWarning v-if="rideHeader" />

    <!-- WhatsApp demo only. A prospective customer evaluating TripPlanner
         lands here from the welcome message's itinerary link; this is their
         way back into the chat to continue the demo.

         Gated on whatsapp_demo_url, which the backend leaves EMPTY on every
         ordinary ride (whatsapp/demo.demo_url_for), so a real traveller's
         trip page is untouched. One field rather than a boolean plus a URL,
         so the two cannot disagree.

         The link's text is pre-filled by the backend with a phrase the
         inbound dispatcher recognises -- it is deliberately not built here,
         because a prefill the parser does not match would open WhatsApp,
         send a message, and be answered with "I did not understand" in
         front of a prospect. -->
    <div
      v-if="showDemoReturn"
      key="whatsapp-demo-return"
      ref="demoReturnRoot"
      class="whatsapp-demo-return"
      :style="demoReturnStyle"
      :dir="isHebrew ? 'rtl' : 'ltr'">
      <a
        :href="rideHeader.ride.whatsapp_demo_url"
        target="_blank"
        rel="noopener"
        class="whatsapp-demo-return-button">
        <WhatsAppBadgeIcon :size="24" />
        <span>{{ t('whatsappDemoReturnButton') }}</span>
      </a>
    </div>
    <div
      v-if="rideFocusDay"
      ref="mapFloatingRoot"
      class="whatsapp-icon-container-with map-container"
      :style="mapLinkStyle">
      <a @click="goToMapRide(rideHeader.ride.id)" class="map-link">
        <img 
          class="map-icon"
          :src="require('@/assets/images/icons/open_map_icon.png')"
          alt="Open Map"
          >
        <span>
          {{ t('mapViewForDay', { day: rideFocusDay }) }}
        </span>
      </a>
    </div>

    <!-- Everything between the header and the trip plan is the design the
         ride manager picked (src/designs/index.js). Keyed: a design change
         must replace it, never patch one layout into another. The trip plan
         below stays outside it, so a design change never refetches the ride. -->
    <component
      :is="design.layout"
      v-if="rideHeader.ride"
      :key="'ride-design-' + design.id"
      :ride="rideHeader.ride"
      :days="rideDays"
      :summaryAvailable="summaryAvailable"
    />
    <b-container
      key="ride-trip-plan"
      class="pb-5"
      >
      <div 
        class="d-flex align-items-center justify-content-center gap-2"
        v-if="!rideUploaded"
        style="min-height: 100px;"
      >
        <h2 class="loading_data_text mb-0">
          {{ t('loadingData') }}
        </h2>
        <div
          class="spinner-border"
          role="status"
          aria-hidden="true"
        ></div>
      </div>
      <div 
      :class="{ 'hidden-at-load': !rideUploaded }"
      class="trip-main-section">
      <div 
        v-if="allRide&&allRide.ride"
      >
        <h3
          class="text-center main-ride-titles">
          {{ t('tripPlan') }}
        </h3>
      </div>

        <div class="container">
           <div class="single_ride_with_map_main_grid" >
             <SingleRideLegacy v-if="isMishpahoolSubdomain" />
             <SingleRide v-else />
             <div class="map-column">
               <!-- Desktop: map always rendered in the grid -->
               <div
                 v-if="allRide && allRide.ride && !isMobile"
                 class="header2 single_ride_map map-with-title-wrapper"
               >
                 <div v-if="rideFocusDay" class="map-title">
                   <h1>{{ t('tripMapForDay', { day: rideFocusDay }) }}</h1>
                 </div>
                 <SingleRideMap />
               </div>
             </div>
           </div>
          <!-- Mobile fullscreen map overlay: lazy-mounted once, toggled with v-show -->
          <div
            v-if="isMobile && mobileMapRequested"
            v-show="mobileMapVisible"
            class="mobile-map-overlay"
          >
            <div class="mobile-back-btn-wrap">
              <a @click="closeMobileMap" :class="['mobile-back-btn', { 'mobile-back-btn--rtl': isHebrew }]">
                <svg class="mobile-back-btn__icon" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
                <span class="mobile-back-btn__label">{{ t('back') }}</span>
              </a>
            </div>
            <div class="full_size_map">
              <SingleRideMap />
            </div>
          </div>
          <!-- Copyright notice in Hebrew -->
          <div
            v-if="rideUploaded"
            class="copyright-notice text-center py-3"
            style="font-size: 16px; color: #666; background-color: #f8f9fa;"
          >
            {{ t('copyrightNotice') }}
          </div>
        </div>
      </div>
    </b-container>
    <!-- <div>
      <div v-if="rideUploaded">
        <PartnershipSection 
          v-if="!isSubdomain"/>
        <HowItWorks
          v-if="!isSubdomain"
        />
      </div>
    </div> -->
    <RideDayNav/>
    <AiChatPanel
      v-if="isUserManager && rideHeader.ride
            && compareToUserId(rideHeader.ride.authorId)
            && !isRideLocked" />
    <WhatsappChet v-if="showOnboardingWhatsapp" />
    <div
      v-if="rideUploaded"
      >
    <PageFooter
      v-if="!isSubdomain"
    />
    </div>

  </div>
</template>

<script>
import WhatsAppBadgeIcon from '@/components/WhatsAppBadgeIcon.vue';
import PageFooter from "@/components/PageFooter.vue";
import SingleRide from "@/components/SingleRide";
import SingleRideLegacy from "@/components/SingleRideLegacy";
import SingleRideMap from "@/components/SingleRideMap";
import SingleRideHeader from "@/components/SingleRideHeader";
import RideDayNav from "@/components/RideSummary/RideDayNav";
import SharedRideWarning from "@/components/SharedRideWarning";
import { designFor } from "@/designs";
import config from '@/common/config';
// import PartnershipSection from "@/components/PartnershipSection";
// import HowItWorks from "@/components/HowItWorks";
import AddAtractionFromImage from "@/components/AddAtractionButton";
import AddAccommodationFromImage from "@/components/AddAccommodationButton";
import WhatsappChet from "@/components/WhatsappChet";
import AiChatPanel from "@/components/AiChatPanel.vue";
import { translationMixin } from "@/mixins/translationMixin";
import {
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
  getFloatingItemStyle,
} from "@/services/floatingItems";
import { mapActions, mapGetters } from "vuex";

// The gap between the top of the viewport and the pinned map, in px: the 6rem
// of `.map_sticky .header2`, resolved. This app sets html { font-size: 10px },
// so 6rem is 60px -- NOT the 96px a default root font size would give.
const MAP_STICKY_TOP_PX = 60;

// Matches the `rootMargin: 100px` the IntersectionObserver this replaced used,
// so the map starts sticking at exactly the same scroll position as before.
const MAP_STICKY_MARGIN_PX = 100;

export default {
  name: "SingleRideWithMap",
  mixins: [translationMixin],
  components: {
    WhatsAppBadgeIcon,
    SingleRide,
    SingleRideLegacy,
    SingleRideMap,
    PageFooter,
    SingleRideHeader,
    RideDayNav,
    SharedRideWarning,
    // PartnershipSection,
    // HowItWorks,
    AddAtractionFromImage,
    AddAccommodationFromImage,
    WhatsappChet,
    AiChatPanel,
  },
  data() {
    return {
      showOnboardingWhatsapp: false,
      syncMapMarkersTimer: null,
      mobileMapRequested: false,
      mobileMapVisible: false,
      floatingMapId: 'floating-map-link',
      demoReturnId: 'floating-whatsapp-demo-return',
    };
  },
  computed: {
    // The design the ride manager picked; classic until the header arrives.
    design() {
      return designFor(this.rideHeader && this.rideHeader.ride && this.rideHeader.ride.presentation_design);
    },
    rideDays() {
      return (this.allRide && this.allRide.attractionsByDay) || [];
    },
    // Whether the layout may draw its trip overview (timeline, poster, map).
    summaryAvailable() {
      return !!(this.allRide && this.allRide.ride && this.allRide.highLevelRideLocations && this.allRide.attractionsByDay) &&
             !config.config.NOT_PRESENTING_THERIDE_SHORTES.includes( this.allRide.ride.id );
    },
    ...mapGetters([ 'userId', 'allRide',
                     'rideId',
                     'rideHeader',
                     'isAppLoggedIn',
                     'compareToUserId',
                     'ridePresentedDay',
                     'rideFocusDay',
                     'rideUploaded',
                     'isUserManager',
                     'isRideLocked',
                     'isMobile',
                     'rideAppMap',
                   ]),
    ...mapGetters('presentUserInfo', ['userExtraInformation']),
    ...mapGetters("theme",  [ "getTheme",
                              "getSubdomain",
                              "isSubdomain",
                            ]),
    isMishpahoolSubdomain() {
      return this.getSubdomain === "mishpahool";
    },
    mapLinkStyle() {
      return getFloatingItemStyle(this.floatingMapId);
    },

    // WhatsApp demo only. The backend leaves whatsapp_demo_url EMPTY on every
    // ordinary ride (whatsapp/demo.demo_url_for), so one field decides both
    // whether the bar exists and where it goes -- there is no second boolean
    // to fall out of step with it.
    showDemoReturn() {
      return !!(this.rideHeader
                && this.rideHeader.ride
                && this.rideHeader.ride.whatsapp_demo_url);
    },

    demoReturnStyle() {
      return getFloatingItemStyle(this.demoReturnId);
    },
  },

  methods:{
    ...mapActions([ 'addRideToUser',
                    'openLoginForm',
                    'rideUpdateMarkerByScrollerLocation',
                    'rideGetTheFocuesDay',
                    'rideUpdateMarkerByDayIndex',
                    'updateMainRideScroleLocation',
                    'userGuideForEditing',
                    'fetchRideHeaderInformation',
                    'updateAttractionRideUploadedWorkAroundInOrderToDisplayTheMainRideAfterFulyLoaded',
                    'aiChatReset',
                    ]),
    ...mapActions('presentUserInfo', [
      'fetchUserExtarInformationForRide',
    ]),
    ...mapActions('language', [ 'loadLanguageFromStorage',
                                'setLanguage'
    ]),
    /**
     * Apply ride language to Vuex, then reload once if Google Maps script language
     * (script-load-time) does not match. See src/main.js VueGoogleMaps load.language.
     */
    syncMapLink() {
      const el = this.$refs.mapFloatingRoot;
      updateFloatingItem(this.floatingMapId, {
        visible: !!this.rideFocusDay,
        height: el ? el.offsetHeight : 0,
      });
    },
    /**
     * Report the demo bar's visibility and measured HEIGHT to the floating
     * stack. The height is what keeps the other fixed items (the map link,
     * the WhatsApp chat button, the cookie banner) from sitting underneath
     * it -- floatingItems stacks by accumulating heights, so an unreported
     * one reads as 0 and the next item overlaps.
     *
     * Measured on $nextTick because the element does not exist until
     * showDemoReturn is true, and rideHeader arrives asynchronously.
     */
    syncDemoReturn() {
      this.$nextTick(() => {
        const el = this.$refs.demoReturnRoot;
        updateFloatingItem(this.demoReturnId, {
          visible: this.showDemoReturn,
          height: el ? el.offsetHeight : 0,
        });
      });
    },
    /**
     * Decide, from the live DOM, whether the map is pinned and where.
     *
     * This replaces an IntersectionObserver that `mounted` pointed at
     * `.single_ride_sumary` once. On ride 26161 that element was REPLACED about
     * a third of a second after mount, and the observer went on watching the
     * old, detached node: measured there, the node it held had
     * `isConnected === false` while a different `.single_ride_sumary` was on the
     * page. A detached element simply reports "not intersecting", so the class
     * either latched ON for good -- map nailed to the top of the page over the
     * footer, whatever the scroll position -- or never came on at all, and which
     * of the two you got depended on how the render raced the first callback.
     * That is the "sometimes" in the report (owner, ride 26161, 2026-10-14).
     *
     * What replaced it was the demo bar above: `v-if` on an UNKEYED element
     * among unkeyed siblings, so when `showDemoReturn` flipped true Vue matched
     * the children by position and reused the b-container element to render it,
     * tearing out `.single_ride_sumary` on the way. Measured: the summary node
     * was removed with `div.whatsapp-demo-return` as its parent. That element
     * now carries a `key`, which stops the reuse -- but the observer is gone
     * regardless, because binding any node once is the fragile part.
     *
     * Ride 1 never showed it because it is not a demo ride, so nothing was
     * inserted there at all.
     *
     * Querying on each scroll cannot go stale: there is no node held across
     * renders, so whatever the DOM currently holds is what gets measured.
     */
    updateMapSticky() {
      const summary = document.querySelector('.single_ride_sumary');
      if (!summary) {
        return;
      }

      // Stuck once the summary has scrolled up out of the 100px-padded
      // viewport, i.e. the reader is in the day plan below it. Only ABOVE:
      // the old observer also counted "still below the viewport", harmless
      // while the summary sat at the top of the page, but the poster design
      // puts a tall poster first, and at the top of the page that pinned the
      // day map over the poster.
      const summaryRect = summary.getBoundingClientRect();
      const stuck = summaryRect.bottom < -MAP_STICKY_MARGIN_PX;
      document.body.classList.toggle('map_sticky', stuck);

      if (!stuck) {
        document.documentElement.style.removeProperty('--map-sticky-top');
        return;
      }

      // Absent on mobile, where the map is a fullscreen overlay rather than a
      // grid column, and for the frames before the ride has rendered.
      const mapEl = document.querySelector('.single_ride_map');
      const mapCol = document.querySelector('.map-column');
      if (!mapEl || !mapCol) {
        return;
      }

      // Width and left keep the pinned map in its column on narrow screens,
      // where queries.css constrains it. Re-read rather than captured once, so
      // a resize or a late-loading image cannot leave them describing an old
      // layout.
      const colRect = mapCol.getBoundingClientRect();
      document.documentElement.style.setProperty('--map-col-width', colRect.width + 'px');
      document.documentElement.style.setProperty('--map-col-left', colRect.left + 'px');

      // The lower bound. `position: fixed` never leaves the viewport on its own,
      // and nothing used to switch it off at the END of the itinerary, so past
      // the last day the map stayed over the copyright line, the cookie banner
      // and the footer. Clamping to the bottom of its column lets it scroll out
      // in step with the last day instead of jumping, which releasing the fixed
      // position would do -- the map's static position is back at day 1.
      const top = Math.min(
        MAP_STICKY_TOP_PX,
        colRect.bottom - mapEl.offsetHeight
      );
      document.documentElement.style.setProperty('--map-sticky-top', top + 'px');
    },
    async syncGMapsLanguageWithRide(rideLanguage) {
      if (!rideLanguage) return;
      await this.setLanguage(rideLanguage);
      const desiredGMapsLanguage = this.getCurrentLanguage === 'he' ? 'iw' : 'en';
      let loadedGMapsLanguage = null;
      try {
        loadedGMapsLanguage = sessionStorage.getItem('googleMapsLanguageLoaded');
      } catch (e) {
        loadedGMapsLanguage = null;
      }
      if (loadedGMapsLanguage && loadedGMapsLanguage !== desiredGMapsLanguage) {
        window.location.reload();
      }
    },
    async goToMapRide(rideId) {
      if (this.isMobile) {
        this.mobileMapRequested = true;
        this.mobileMapVisible = true;
        this.$nextTick(() => window.dispatchEvent(new Event('resize')));
        if (this.rideAppMap) {
          // Map already mounted: always refresh markers and zoom for the current day
          const dayIndex = await this.rideGetTheFocuesDay();
          this.rideUpdateMarkerByDayIndex(dayIndex);
        }
        // First mount: rideAppMap watcher handles it after the map initialises
      } else {
        await this.rideUpdateMarkerByScrollerLocation(true);
        const dayNumber = this.ridePresentedDay;
        this.$router.push('/full_screen_single_ride_map/' + rideId + '/' + dayNumber);
      }
    },
    closeMobileMap() {
      this.mobileMapVisible = false;
    },
    deferInstallPrompt(event) {
      event.preventDefault();
    },
    scrollToFirstDayIfRequested() {
      const scrollToDay = this.$route.query.scrollToDay;
      const isOnboarding = this.$route.query.onboarding === 'true';
      if (!isOnboarding && scrollToDay !== '0' && scrollToDay !== 0) return;
      const tryScroll = (attempt, maxAttempts) => {
        const firstDayEl = document.getElementById('daily_attraction_day_0');
        if (firstDayEl) {
          firstDayEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.$store.commit('setShowDay0AddActivityHint', true);
          setTimeout(() => this.$store.commit('setShowDay0AddActivityHint', false), 15000);
          const q = { ...this.$route.query };
          delete q.scrollToDay;
          delete q.onboarding;
          const afterScroll = () => {
            localStorage.setItem('workAroundToSetTheScroleLocationAtTheMAinPage', String(window.scrollY));
            this.$router.replace({ path: this.$route.path, query: q });
          };
          setTimeout(afterScroll, 600);
          return;
        }
        if (attempt < maxAttempts) {
          setTimeout(() => tryScroll(attempt + 1, maxAttempts), 150);
        }
      };
      this.$nextTick(() => setTimeout(() => tryScroll(0, 20), 100));
    },
    scheduleSyncSingleRideMapMarkers() {
      if (this.isMobile) return;
      if (this.syncMapMarkersTimer) {
        clearTimeout(this.syncMapMarkersTimer);
      }
      this.syncMapMarkersTimer = setTimeout(() => {
        this.syncMapMarkersTimer = null;
        this.syncSingleRideMapMarkersAfterRideDataChange();
      }, 80);
    },
    async syncSingleRideMapMarkersAfterRideDataChange() {
      if (this.isMobile) return;
      if (!this.rideUploaded || !this.allRide?.attractionsByDay?.length) return;
      await this.$nextTick();
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 0));
      const dayIndex = await this.rideGetTheFocuesDay();
      await this.rideUpdateMarkerByDayIndex(dayIndex);
    },
  },
  created() {
    // Load saved language preference
    this.loadLanguageFromStorage();
    
    const rideIdFromUrl = this.$route.params.id;
    if (rideIdFromUrl) {
      this.$store.commit("setLowedRideId", rideIdFromUrl);
    }
    this.fetchRideHeaderInformation()
    this.fetchUserExtarInformationForRide()
    window.addEventListener("scroll", this.rideUpdateMarkerByScrollerLocation);
    window.addEventListener('scroll', this.updateMainRideScroleLocation);
    window.addEventListener('scroll', this.userGuideForEditing);
    // window.addEventListener('scroll', this.updateAttractionRideUploadedWorkAroundInOrderToDisplayTheMainRideAfterFulyLoaded, { once: true });

  },
  watch: {
    // Navigating ride A -> ride B by URL reuses this component instance, so
    // beforeDestroy never fires and the chat is never reset. The transcript,
    // the applied-card set and the auto-continue bookkeeping are all keyed by
    // message index with no ride on them: left alone, ride A's conversation
    // displays over ride B, aiChatSend posts A's history against B's id, and
    // A's card indices land on B's cards.
    // Only on a real change between two rides: the first load goes null -> id
    // and has nothing to clear, and clearing it there would close a panel the
    // manager had already opened.
    rideId(newId, oldId) {
      if (oldId != null && newId !== oldId) this.aiChatReset();
    },
    rideFocusDay() {
      this.$nextTick(() => this.syncMapLink());
    },
    // On first mobile map mount rideAppMap transitions null→map.
    // goToMapRide ran before mount so markers were skipped; re-run now.
    rideAppMap(newMap) {
      if (newMap && this.isMobile && this.mobileMapVisible) {
        this.rideGetTheFocuesDay().then(dayIndex => {
          this.rideUpdateMarkerByDayIndex(dayIndex);
        });
      }
    },
    isAppLoggedIn(newVal) {
      if( newVal && this.allRide){
        this.fetchRideHeaderInformation()
        this.fetchUserExtarInformationForRide()
    
      }
    },
    rideUploaded: async function (newVal) {
      if (newVal) {
        // Restore scroll position after ride is fully uploaded and displayed
        const savedPosition = localStorage.getItem('scrollPositionToRestore');
        if (savedPosition !== null) {
          // Use setTimeout to ensure DOM is fully rendered after rideUploaded becomes true
          setTimeout(() => {
            window.scrollTo(0, parseInt(savedPosition, 10));
            localStorage.removeItem('scrollPositionToRestore');
          }, 200); // Increased timeout to ensure all content is rendered
        }
        // Scroll to first day when coming from onboarding (or legacy scrollToDay)
        this.scrollToFirstDayIfRequested();
        if (this.$route.query.onboarding === 'true') {
          this.$store.commit('setOnboarding', true);
        }
        if (this.rideHeader?.ride?.language) {
          await this.syncGMapsLanguageWithRide(this.rideHeader.ride.language);
        }
        // this.scheduleSyncSingleRideMapMarkers();
      }
    },
    allRide: {
      handler() {
        if (!this.rideUploaded || !this.allRide?.attractionsByDay?.length) return;
        this.scheduleSyncSingleRideMapMarkers();
      },
      deep: true,
    },
    // rideHeader arrives asynchronously, so the bar's element does not exist
    // at mount. Without this the stack never learns its height and the other
    // fixed items overlap it.
    showDemoReturn: {
      immediate: true,
      handler() {
        this.syncDemoReturn();
      },
    },
    'rideHeader.ride.language': {
      immediate: true,
      async handler(newLang) {
        if (!this.rideUploaded || !newLang) return;
        await this.syncGMapsLanguageWithRide(newLang);
      },
    },
  },
  mounted() {
    // Keeps Chrome's own "install app" banner off the trip page (moved here
    // from SingleRideSumary, whose install button is long gone).
    window.addEventListener('beforeinstallprompt', this.deferInstallPrompt);
    registerFloatingItem({
      id: this.floatingMapId,
      priority: 45,
      anchor: 'right',
      zIndex: 1001,
    });
    // anchor 'right', NOT 'full'. This was a full-width bottom bar and it
    // covered the "show map" button (owner, 2026-10-08). The cause is in
    // services/floatingItems: sortedVisibleItems filters BY ANCHOR, so
    // 'full' and 'right' are two independent stacks that both sit at
    // bottom -- a persistent 'full' bar necessarily overlaps every
    // right-anchored button (map link, WhatsApp chat, AI panel, documents).
    //
    // The other way out would be --floating-stack-bottom-extra, which lifts
    // the whole stack. That is not available: RideDayNav.vue already
    // sets it for its sticky day-nav, and two writers of one variable means
    // last-one-wins and a silently broken layout.
    //
    // priority 15 makes it the BOTTOM-most item in the right stack -- the
    // easiest to reach with a thumb, which is right for the prospect's
    // primary call to action. Everything else lifts above it automatically.
    registerFloatingItem({
      id: this.demoReturnId,
      priority: 15,
      anchor: 'right',
      zIndex: 1002,
    });
    this.$nextTick(() => {
      this.syncMapLink();
      this.syncDemoReturn();
    });
    const onboardingActive = localStorage.getItem('onboardingActive') === '1';
    this.showOnboardingWhatsapp = onboardingActive;
    if (onboardingActive) {
      this.$store.commit('setOnboarding', true);
    }
    this.$store.commit("rideSetPresentedDay", null);
    // When navigating with scrollToDay=0 and ride already loaded, watcher won't run; scroll from here
    if (this.rideUploaded && (this.$route.query.scrollToDay === '0' || this.$route.query.scrollToDay === 0)) {
      this.scrollToFirstDayIfRequested();
    }
    if (this.$route.query.showShareHint === '1') {
      this.$store.commit('setShowShareRideHint', true);
      setTimeout(() => this.$store.commit('setShowShareRideHint', false), 15000);
      const q = { ...this.$route.query };
      delete q.showShareHint;
      setTimeout(() => this.$router.replace({ path: this.$route.path, query: q }), 100);
    }
    // The map's stickiness is recomputed from the LIVE DOM on every scroll
    // rather than through an IntersectionObserver bound once in `mounted`.
    // See updateMapSticky for why that observer could not be kept.
    window.addEventListener('scroll', this.updateMapSticky, { passive: true });
    window.addEventListener('resize', this.updateMapSticky);
    // The ride renders asynchronously, so the first honest measurement is only
    // possible after it has; until then every rect is zero.
    this.$nextTick(() => this.updateMapSticky());
  },
  
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.deferInstallPrompt);
    this.aiChatReset();
    unregisterFloatingItem(this.floatingMapId);
    unregisterFloatingItem(this.demoReturnId);
  },

  destroyed() {
    if (this.syncMapMarkersTimer) {
      clearTimeout(this.syncMapMarkersTimer);
      this.syncMapMarkersTimer = null;
    }
    window.removeEventListener('scroll',this.rideUpdateMarkerByScrollerLocation);
    window.removeEventListener('scroll', this.updateMainRideScroleLocation);
    window.removeEventListener('scroll', this.updateMapSticky);
    window.removeEventListener('resize', this.updateMapSticky);
    // The class sits on <body> and the variables on <html>, both of which
    // outlive this view. Left behind, the next page starts out believing it has
    // a pinned map.
    document.body.classList.remove('map_sticky');
    document.documentElement.style.removeProperty('--map-sticky-top');
    window.removeEventListener('scroll', this.userGuideForEditing);
    window.removeEventListener('scroll', this.updateAttractionRideUploadedWorkAroundInOrderToDisplayTheMainRideAfterFulyLoaded, { once: true });
    // at the end of the firest time that the user adding this trip from images we should remove this condition
    this.$store.commit("setIsFirstTimeAddingImages", false);
  },

  metaInfo() {
    var canonicalUrl = `https://tripplanner.co.il${this.$route.fullPath}`;
    var rideTitle = 'TripPlanner';
    var rideDescription = this.t('singleRideMetaTitle');
    var rideImage = '';

    if (this.rideHeader.ride) {
      if (this.rideHeader.ride.title) {
        const brandName = this.isSubdomain && this.userExtraInformation?.name
          ? this.userExtraInformation.name
          : 'TripPlanner';
        rideTitle = this.rideHeader.ride.title + this.t('singleRideMetaTitleSuffix').replace('TripPlanner', brandName);
      }
      if (this.rideHeader.ride.text) {
        rideDescription = this.rideHeader.ride.text.replace(/<[^>]*>/g, '').substring(0, 155);
      }
      if (this.rideHeader.ride.cover_image_url) {
        rideImage = this.rideHeader.ride.cover_image_url;
      } else if (this.rideHeader.ride.top_page_image_url) {
        rideImage = this.rideHeader.ride.top_page_image_url;
      }
      if (this.rideHeader.ride.is_based_ride) {
        canonicalUrl = `https://tripplanner.co.il${this.$route.fullPath}`;
      } else {
        canonicalUrl = 'https://tripplanner.co.il/single_ride_with_map/' + this.rideHeader.ride.based_ride_id;
      }
    }

    const breadcrumbName = this.rideHeader.ride && this.rideHeader.ride.title
      ? this.rideHeader.ride.title
      : this.t('singleRideBreadcrumbTitle');

    const metaInfo = {
      title: this.$route.meta.title || rideTitle,
      meta: [
        { property: 'og:title', content: rideTitle },
        { property: 'og:description', content: rideDescription },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: `https://tripplanner.co.il${this.$route.fullPath}` },
        { name: 'description', content: rideDescription }
      ],
      link: [
        { rel: 'canonical', href: canonicalUrl }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'TripPlanner', item: 'https://tripplanner.co.il' },
              { '@type': 'ListItem', position: 2, name: breadcrumbName, item: canonicalUrl }
            ]
          }
        }
      ]
    };

    if (rideImage) {
      metaInfo.meta.push({ property: 'og:image', content: rideImage });
      metaInfo.script.push({
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'TouristTrip',
          name: this.rideHeader.ride.title,
          description: rideDescription,
          image: rideImage,
          url: canonicalUrl
        }
      });
    }

    return metaInfo;
  }

};

</script>


<style scoped>
.language-toggle-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 1050;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.loading_data_text {
  font-size: 3rem;
}

.map-with-title-wrapper {
  margin-bottom: 1rem;
}

.map-title {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: right;
  padding-right: 1rem;
  color: #2c3e50;
  font-weight: 600;
  position: relative;
  display: inline-block;
}

.map-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  right: 0;
  width: 100%;
  height: 3px;
  background: var(--primary-background);
  border-radius: 2px;
}

/* English layout adjustments */
.home[dir="ltr"] .map-title {
  text-align: left;
  padding-left: 1rem;
  padding-right: 0;
}

.home[dir="ltr"] .map-title::after {
  left: 0;
  right: auto;
}

/* Global RTL/LTR adjustments */
.home[dir="ltr"] .text-center {
  text-align: center !important;
}

.home[dir="ltr"] .text-end,
.home[dir="ltr"] .text-right {
  text-align: left !important;
}

.home[dir="rtl"] .text-end,
.home[dir="rtl"] .text-right {
  text-align: right !important;
}

/* Title and heading alignments for English */
.home[dir="ltr"] .main-ride-titles,
.home[dir="ltr"] .trip-timeline-section h3,
.home[dir="ltr"] .ride-day-header,
.home[dir="ltr"] .day-number,
.home[dir="ltr"] .ride-detailes,
.home[dir="ltr"] .activity-name,
.home[dir="ltr"] .activity-text,
.home[dir="ltr"] .activity-description,
.home[dir="ltr"] .attraction-title,
.home[dir="ltr"] .attraction-name {
  text-align: left !important;
}

/* Center trip header title for all languages - override global RTL/LTR rules */
.home[dir="rtl"] .trip-header-ride-title,
.home[dir="ltr"] .trip-header-ride-title,
.home .trip-header-ride-title {
  text-align: center !important;
}

/* Center share trip button for all languages - override global RTL/LTR rules */
.home[dir="rtl"] .trip-share-btn,
.home[dir="ltr"] .trip-share-btn,
.home .trip-share-btn {
  text-align: center !important;
}

/* Center edit trip button for all languages - override global RTL/LTR rules */
.home[dir="rtl"] .trip-edit-btn,
.home[dir="ltr"] .trip-edit-btn,
.home .trip-edit-btn {
  text-align: center !important;
}

/* Add spacing around trip plan heading */
.main-ride-titles {
  margin: 2rem 1.5rem !important;
  padding: 1rem 0 !important;
}

/* Button and form alignments for English */
.home[dir="ltr"] .trip-btn-wraper,
.home[dir="ltr"] .trip-default-btn,
.home[dir="ltr"] .user-more-rides {
  text-align: left !important;
}

/* Flex direction adjustments for English */
.home[dir="ltr"] .centering_with_gap {
  flex-direction: row-reverse;
}

.home[dir="ltr"] .ride-date-and-location {
  flex-direction: row-reverse;
  text-align: left !important;
}

/* Language toggle positioning adjustments */
.home[dir="ltr"] .language-toggle-container {
  left: 20px;
  right: auto;
}

@media (max-width: 768px) {
  .home[dir="ltr"] .language-toggle-container {
    left: 10px;
    right: auto;
  }
}

/* Map button icon positioning - always on the right side */
.map-link {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  position: relative !important;
}

/* Fixed position for the map icon - always on the right side */
.map-link .map-icon {
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  max-width: 28px !important;
  max-height: 32px !important;
  width: auto !important;
  height: auto !important;
}

.map-link span {
  text-align: center !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-right: 45px; /* Make space for the larger icon on the right */
}

/* Keep map icon on the right side for both languages */
[dir="rtl"] .map-link .map-icon,
[dir="ltr"] .map-link .map-icon {
  right: 10px !important;
  left: auto !important;
}

[dir="rtl"] .map-link span,
[dir="ltr"] .map-link span {
  text-align: center !important;
  padding-right: 45px;
  padding-left: 0;
}

.mobile-map-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: #fff;
}

.mobile-back-btn-wrap {
  position: absolute;
  bottom: calc(80px + env(safe-area-inset-bottom));
  right: 1rem;
  z-index: 10;
}

.mobile-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190px;
  background: var(--secondary-background);
  padding: 10px 15px;
  border-radius: 10px;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

/* Hebrew: icon pinned to right (out of flow), text centered by justify-content */
.mobile-back-btn--rtl .mobile-back-btn__icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 0;
}

.mobile-back-btn:hover {
  filter: brightness(0.9);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.mobile-back-btn__icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-left: 6px;
}

.mobile-back-btn__label {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .language-toggle-container {
    top: 70px;
    right: 10px;
    padding: 2px;
  }

}


/* WhatsApp demo return pill. px, never rem: this app sets
   html { font-size: 10px }, so a Bootstrap-ish 1rem resolves to 10px.

   position/bottom/right/z-index are NOT set here. They come from
   services/floatingItems via :style, which stacks every fixed element on
   this page -- there are five or six -- so they cannot overlap. Setting them
   here is what put this on top of the "show map" button. */
.whatsapp-demo-return {
  display: flex;
  max-width: calc(100vw - 40px);
}

.whatsapp-demo-return-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  /* >=44px: tapped on a phone, which is where a prospect reads a WhatsApp
     message and follows its link. */
  min-height: 46px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  color: #0B3B36;
  /* Opaque, not translucent: the page scrolls underneath it. */
  background-color: #ffffff;
  border: 1px solid #25D366;
  border-radius: 999px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.whatsapp-demo-return-button:hover,
.whatsapp-demo-return-button:focus {
  background-color: #F4F8F7;
  color: #0B3B36;
  text-decoration: none;
}

/* The hint line is gone with the full-width bar: a pill in a stack of five
   other buttons has no room for a second line, and the button's own label
   already says where it goes. The translation key stays in
   translationMixin.js -- it costs nothing and the wording is wanted if this
   ever becomes a bar again. */
</style>
